module.exports = __webpack_public_path__ + "img/chess_japanchess04.4e56c1c4.png";